

export const PublishMessageAddToProject =  (msg) => {
    const eventData= {
        "fn": "cnsAddToProject",
        "data": msg,//JSON.stringify(msg),
        "IsValid": true
       }
      
    window.parent.postMessage(eventData,'*')  
}

export const PublishMessageAddToProjectEZ3 =  (msg) => {
    const eventData= {
        "fn": "EZAddToProject",
        "data": msg,//JSON.stringify(msg),
        "IsValid": true
       }
      
    window.parent.postMessage(eventData,'*')  
}

export const PublishMessageClose =  () => {
    const eventData= {
        "fn": "cnsClose",
        "data": "",
        "IsValid": true
       }

    window.parent.postMessage(eventData,'*')  
}

export const PublishMessageSolution =  (msg) => {
    const eventData= {
        "fn": "cnsSolution",
        "data": JSON.stringify(msg),
        "IsValid": true
       }
      
    window.parent.postMessage(eventData,'*')  
}

export const PublishMessageSolutionConsoleEvent =  (msg) => {
    console.log("EZ msg : ",msg)
    const eventData= {
        "fn": "cnsSolutionDataConsole",
        "data": JSON.stringify(msg),
        "IsValid": true
       }
      
    window.parent.postMessage(eventData,'*')  
}